import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text, Pivot, PivotItem, Shimmer, ShimmerElementType, Link } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useHydration, useBreakpoint } from '@agoras/hooks';
import { pivotStyles, linkStyles } from './styles.esm.js';
import { useQuery } from '@tanstack/react-query';
import RestClient from '@agoras/rest-client';
import { useState } from 'react';
import { tileDataQueryKey } from '../prefetchQuery.esm.js';
import { popularSolutionsData, prefetchedItemData } from '../data.esm.js';
import { appsourceRouteMatch } from '../../../router/appsource.esm.js';
import logger from '@agoras/logger';
import { homeContext } from '../context.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var defaultTabText = prefetchedItemData.title, defaultTabType = prefetchedItemData.queryKey, defaultTabKey = prefetchedItemData.queryValue;
var PopularSolutions = function(param) {
    var navigate = param.navigate, onRenderTiles = param.onRenderTiles, locale = param.locale;
    var _data_apps;
    var t = useTranslation('home').t;
    var isHydrated = useHydration();
    var _useBreakpoint = _sliced_to_array(useBreakpoint('sm', 'md'), 1), isMobile = _useBreakpoint[0];
    var _useBreakpoint1 = _sliced_to_array(useBreakpoint('lg'), 1), isLarge = _useBreakpoint1[0];
    var _useBreakpoint2 = _sliced_to_array(useBreakpoint('xl'), 1), isXL = _useBreakpoint2[0];
    var _useBreakpoint3 = _sliced_to_array(useBreakpoint('xxl', 'xxxl'), 1), isAboveXXL = _useBreakpoint3[0];
    var tilesCount = isMobile ? 1 : isLarge ? 2 : isXL ? 3 : 5;
    var _useState = _sliced_to_array(useState(null), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var tabKey = (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.props.itemKey) || defaultTabKey;
    var tabType = (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.props.itemProp) || defaultTabType;
    var tabText = (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.props.headerText) || defaultTabText;
    var handleTabClick = function(item) {
        if (item) {
            setSelectedTab(item);
            logger.info(JSON.stringify({
                tab: item.props.itemKey
            }), _object_spread({
                action: 'Click',
                actionModifier: 'Tab'
            }, homeContext));
        }
    };
    var _useQuery = useQuery({
        queryKey: tileDataQueryKey(tabKey),
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            RestClient.AppSource.getTileData({
                                query: _define_property({}, tabType, tabKey)
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                }
            });
        }),
        enabled: true,
        staleTime: Infinity
    }), data = _useQuery.data, isLoading = _useQuery.isLoading, isError = _useQuery.isError;
    var handleLinkClick = function(param) {
        var navigateOptions = param.navigateOptions;
        var appsourceRoute = appsourceRouteMatch(_object_spread_props(_object_spread({}, navigateOptions), {
            params: {
                locale: locale
            }
        }));
        logger.info(JSON.stringify({
            href: "".concat(appsourceRoute.pathname).concat(appsourceRoute.search)
        }), _object_spread({
            action: 'Click',
            actionModifier: 'Internal Link'
        }, homeContext));
        navigate === null || navigate === void 0 ? void 0 : navigate(navigateOptions);
    };
    return /*#__PURE__*/ jsxs(Stack, {
        horizontalAlign: "center",
        styles: {
            root: {
                width: '100%',
                padding: '56px 16px'
            }
        },
        children: [
            /*#__PURE__*/ jsx(Text, {
                variant: "xxLarge",
                as: "h2",
                styles: {
                    root: {
                        textAlign: 'center',
                        margin: 0
                    }
                },
                children: t('Popular solutions')
            }),
            /*#__PURE__*/ jsx(Pivot, {
                styles: pivotStyles,
                selectedKey: tabKey,
                onLinkClick: handleTabClick,
                headersOnly: true,
                children: popularSolutionsData.map(function(param) {
                    var title = param.title, queryKey = param.queryKey, queryValue = param.queryValue;
                    return /*#__PURE__*/ jsx(PivotItem, {
                        headerText: t(title),
                        itemKey: queryValue,
                        itemProp: queryKey,
                        headerButtonProps: {
                            disabled: !isHydrated
                        }
                    }, queryValue);
                })
            }),
            isLoading || isError ? /*#__PURE__*/ jsx(Stack, {
                styles: {
                    root: {
                        marginTop: '24px'
                    }
                },
                children: /*#__PURE__*/ jsx(Shimmer, {
                    shimmerElements: Array.from({
                        length: tilesCount
                    }, function() {
                        return [
                            {
                                type: ShimmerElementType.line,
                                width: 236,
                                height: 380
                            },
                            {
                                type: ShimmerElementType.gap,
                                width: 16,
                                height: 20
                            }
                        ];
                    }).flat()
                })
            }) : onRenderTiles === null || onRenderTiles === void 0 ? void 0 : onRenderTiles({
                carousel: !isAboveXXL,
                data: (data === null || data === void 0 ? void 0 : (_data_apps = data.apps) === null || _data_apps === void 0 ? void 0 : _data_apps.dataList) || []
            }),
            /*#__PURE__*/ jsx(Link, {
                styles: linkStyles,
                onClick: function() {
                    return handleLinkClick({
                        navigateOptions: {
                            type: 'App',
                            query: _define_property({}, tabType, tabKey)
                        }
                    });
                },
                children: t("See all ".concat(tabText, " solutions"))
            })
        ]
    });
};

export { PopularSolutions as default };
